<template>
  <el-dialog :visible.sync="dialogVisible" width="312px" :close-on-click-modal="false">
    <p class="content">{{title}}</p>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm" style="margin-right:10px">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  props:{
    title:{
        type:String,
        default:""
    }
  },
  methods: {
    // 显示
    show() {
      this.dialogVisible = true;
    },
    // 确定
    confirm(){
        this.$emit("confirms")
        this.dialogVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.content{
    text-align: center;
    font-size: 16px;
    color: #222;
}
::v-deep .el-dialog__header {
    padding: 5px 20px 10px;
}
::v-deep .el-dialog__body{
    padding: 27px 20px;
}
::v-deep .el-dialog__footer{
    display: flex;
    justify-content: center;
    .el-button{
        width: 72px;
        height: 32px;
        line-height: 0;
        border-radius: 2px;
    }
}
</style>